import React from "react";
import { Link } from "react-router-dom";
import { useLang } from "../i18n";

export default function Sell() {
  const { t } = useLang();
  return (
    <div data-testid="sell-page">
      {/* HERO */}
      <section className="relative min-h-[70vh] flex items-end pb-20 overflow-hidden grain">
        <div className="absolute inset-0">
          <img src="https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=2000&q=80" alt="" className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-[#0F0F0F]" />
        </div>
        <div className="relative z-10 max-w-[1200px] mx-auto px-6 md:px-12 w-full">
          <div className="eyebrow mb-5 reveal">{t.sell.eyebrow}</div>
          <h1 className="font-serif text-5xl md:text-7xl text-[#F5F5F0] tracking-tight leading-[0.95] max-w-4xl reveal reveal-delay-1">
            {t.sell.title}
          </h1>
        </div>
      </section>

      {/* INTRO */}
      <section className="py-24 md:py-32 bg-[#0F0F0F]">
        <div className="max-w-[1000px] mx-auto px-6 md:px-12">
          <p className="font-serif text-2xl md:text-3xl text-[#F5F5F0] leading-relaxed">
            {t.sell.intro}
          </p>
        </div>
      </section>

      {/* STRATEGY */}
      <section className="py-24 md:py-32 bg-[#0B0B0B] border-t border-white/5">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
          <div className="md:col-span-6">
            <img src="https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?w=1400&q=80" alt="" className="w-full h-[460px] object-cover" />
          </div>
          <div className="md:col-span-6 md:pl-8">
            <div className="eyebrow mb-4">01</div>
            <h2 className="font-serif text-3xl md:text-5xl text-[#F5F5F0] leading-tight mb-6">{t.sell.strategy_title}</h2>
            <span className="gold-line mb-6"></span>
            <p className="text-white/60 leading-relaxed text-lg">{t.sell.strategy_body}</p>
          </div>
        </div>
      </section>

      {/* STEPS */}
      <section className="py-24 md:py-36 bg-[#0F0F0F] border-t border-white/5">
        <div className="max-w-[1200px] mx-auto px-6 md:px-12">
          <div className="max-w-2xl mb-20">
            <div className="eyebrow mb-4">{t.sell.steps_title}</div>
            <h2 className="font-serif text-4xl md:text-5xl text-[#F5F5F0] tracking-tight">{t.sell.steps_title}</h2>
          </div>
          <div className="space-y-0">
            {t.sell.steps.map((s, i) => (
              <div
                key={i}
                className="grid grid-cols-1 md:grid-cols-12 gap-6 py-10 border-b border-white/5 group"
                data-testid={`sell-step-${i}`}
              >
                <div className="md:col-span-2 font-serif text-5xl text-[#D4AF37]">{s.n}</div>
                <div className="md:col-span-4">
                  <h3 className="font-serif text-2xl md:text-3xl text-[#F5F5F0]">{s.t}</h3>
                </div>
                <div className="md:col-span-6 text-white/60 leading-relaxed flex items-center">{s.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-28 md:py-36 bg-[#0B0B0B] border-t border-white/5 text-center">
        <div className="max-w-3xl mx-auto px-6">
          <h2 className="font-serif text-4xl md:text-5xl text-[#F5F5F0] tracking-tight mb-10 leading-tight">
            {t.sell.cta}
          </h2>
          <Link to="/contact" className="btn-gold" data-testid="sell-cta">{t.cta.confidential_evaluation}</Link>
        </div>
      </section>
    </div>
  );
}
